import { DefaultTheme } from 'styled-components'

import { Spacings } from '@/theme/defaults'

export const withBorder = (theme: DefaultTheme, spacing: keyof Spacings, withBorder = true) => {
  if (withBorder) return `calc(${theme.space[spacing]} - ${theme.border.size['1']})`
  return theme.space[spacing]
}
